import React from 'react';
import './Class.css';
import class7 from '../../Images/Class-7.png';
import {Helmet} from "react-helmet";
const Class7 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Chhatrapati - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class7}
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1199/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 5999/-</p>
  <a href="https://rzp.io/rzp/ChhattraPati" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Chhattra<span className='highlight'>pati</span>(Class-<span className='highlight'>7</span>)</h2>
        
      </div>
    </div>
 {/* Batch Details Section */}
 <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Personalized Attention</strong>  
    <ul>
      <li>🧑‍🎓Only 10 students per batch to focus on individual growth.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects Covered</strong>  
    <ul>
      🧮 Mathematics
      🔬 Science
      📖 English
      🌍 Social Science (SST)
      ✍️ Hindi
    </ul>
  </li>
  <li><strong>3️⃣Daily Live Classes</strong>  
    <ul>
      <li>⏳Two 1-hour sessions daily with top-notch tutors for a solid understanding.</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving Support</strong>  
    <ul>
      <li>💬Got a question? Ask anytime and get instant help!</li>
    </ul>
  </li>
  <li><strong>5️⃣Interactive & Fun Learning</strong>  
    <ul>
      <li>🎥Enjoy live, interactive classes with engaging activities and discussions.</li>
    </ul>
  </li>
  <li><strong>6️⃣Comprehensive Study Material</strong>  
    <ul>
      <li>📝Get class notes, practice sheets, and recorded lectures for uninterrupted learning.</li>
    </ul>
  </li>
  <li><strong>7️⃣Exciting Live Quizzes</strong>  
    <ul>
      <li>🏆Compete in fun quizzes, earn prizes and badges, and challenge your knowledge!</li>
    </ul>
  </li>
  <li><strong>8️⃣Weekly PTMs & Progress Reports</strong>  
    <ul>
      <li>📈Regular updates through Parent-Teacher Meetings to keep you informed.</li>
    </ul>
  </li>
  <li><strong>9️⃣Weekly Tests & Feedback</strong>  
    <ul>
      <li>✍️Consistent evaluations to help you stay ahead and improve.</li>
    </ul>
  </li>
  <li><strong>📩Need More Info?</strong>  
    <ul>
      <li>Contact us at  <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Chhatrapati'</span> to conquer Class 7 with confidence and excellence!</strong>  
  </li>
</ul>

    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join This Batch?</h3>
            <p>
            🎓 Designed for Class 7 students who wish to build stronger academic skills and prepare for future challenges.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Will the Classes Be Held?</h3>
            <p>💻 Classes are held on Zoom. You’ll get the links via the WhatsApp group.</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p>💬 24/7 doubt-solving support—help is always available for your queries!</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?</h3>
            <p>
            📼 All sessions are recorded and can be accessed later for easy catch-up.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?</h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes are mandatory to evaluate your progress.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I Get a Refund After Batch Purchase?
            </h3>
            <p>
            💡 Refunds are not possible after batch purchase. We invest significantly in providing high-quality education. Please make an informed decision.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class7;
